import { useState } from 'react'
import { useScribeRecorder, type ScribeRecording } from '@/components/scribe/useScribeRecorder'
import { blobToBase64, captureSignupScribe } from '@/modules/scribe/api'

export function useBusinessDictation(onText: (text: string) => void, onError: (message: string) => void) {
  const [transcribing, setTranscribing] = useState(false)
  async function captured(recording: ScribeRecording) {
    setTranscribing(true)
    try {
      const result = await captureSignupScribe({ audio: await blobToBase64(recording.blob), mimeType: recording.mimeType,
        durationMs: recording.durationMs, fields: [{ key: 'answer', label: 'The owner’s reply to Aria' }], context: 'Business setup. Transcribe the owner’s words for review before sending.' })
      if (result.transcript) onText(result.transcript)
      else onError('No words were captured. Try again or type your answer.')
    } catch (error) { onError(error instanceof Error ? error.message : 'Couldn’t transcribe. You can type your answer.') }
    finally { setTranscribing(false) }
  }
  const recorder = useScribeRecorder({ onRecording: captured, onError: (_kind, message) => onError(message) })
  function toggle() { if (recorder.state === 'recording') recorder.stop(); else void recorder.start() }
  return { live: recorder.state === 'recording', pending: recorder.state === 'requesting' || transcribing, toggle }
}
